export default {
    DYNAMICS: 'Dynamics',
    PIPEDRIVE: 'Pipedrive',
    SALES_FORCE: 'SalesForce',
    AUTOTASK: 'Autotask'
}